import React, {Component} from "react";
import {Icon, Popconfirm} from "antd";

export default class TreeOperation extends Component {
    render() {
        const {
            data,
            onTreeAdd,
            onTreeEdit,
            onTreeDelete,
            root,
            isShowAddOperate
        } = this.props;
        const isRooter = root && root.key === data.key;
        return (
            <div className="operate-btns" onClick={e => e.stopPropagation()}>
                {isShowAddOperate ?
                    <Icon style={{marginLeft: 10}} onClick={() => onTreeAdd(data)} type="plus"/> : null}
                {
                    isRooter ? null : <>
                        <Icon style={{marginLeft: 10}} onClick={() => onTreeEdit(data)} type="form"/>
                        <Popconfirm
                            title={`确定删除：${data.title}`}
                            onConfirm={() => onTreeDelete(data)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Icon style={{marginLeft: 10}} type="close"/>
                        </Popconfirm>
                    </>
                }
            </div>
        );
    }
}

